import { Component } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  showHeader=false
  constructor(private router: Router){

   
   }

   onActivate(event:any) {
    console.log(event)
    window.scroll(0,0);

     console.log(this.router.url); // This prints a loot of routes on console

     if (this.router.url === '/propuestas') {
       this.showHeader = false;
     } else {
       this.showHeader = true;
     }
    
  }
  
}
